import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {
  AuthorizeCreditCardRequest,
  ReportBillingInfo,
  TransactionId
} from '@store/reports/reports.model';
import { Observable } from 'rxjs';
import { MatLegacyDialog as MatDialog, MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import { PurchaseComponent } from '@shared/components/purchase/purchase.component';
import { ModalType } from '@shared/models/modal.model';

@Injectable({
  providedIn: 'root'
})
export class PurchaseService {
  private dialogRef: MatDialogRef<PurchaseComponent>;

  constructor(private readonly http: HttpClient,
              private readonly dialog: MatDialog) { }

  openPurchaseDialog(data: {reportBillingInfo: ReportBillingInfo, str?: string}): void {
    if (this.dialogRef) {
      this.dialogRef.close();
    }

    this.dialogRef = this.dialog.open(PurchaseComponent, {
      panelClass: ModalType.SCROLLABLE.concat(ModalType.SMALL),
      data
    });
  }

  closeDialog(): void {
    if (!this.dialogRef) {
      return;
    }

    this.dialogRef.close();
    this.dialogRef = null;
  }

  authorizeCreditCard(authorizeCreditCardRequest: AuthorizeCreditCardRequest): Observable<TransactionId> {
    return this.http.post<TransactionId>('/api/authorize-credit-card', authorizeCreditCardRequest);
  }
}
